import { createContext, useCallback, useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router";
import { bookApi } from "./api";


export const LayoutContext = createContext();


export default function LayoutProvider({ children }) {
    const navigate = useNavigate();
    const location = useLocation();

    const [ bookSize, setBookSize ] = useState(null);
    // Модалка "Мои книги"
    const [ showMyBooksModal, setShowMyBooksModal ] = useState(false);

    const [ sidebarOpen, setSidebarOpen ] = useState(null);

    const [ currentBook, setCurrentBook ] = useState(null);  // полный объект книги с сервера
    const [ bookId, setBookId ] = useState(null);             // UUID текущей книги

    // Книги, отмеченные галочкой для заказа (массив ID)
    const [ selectedBookIds, setSelectedBookIds ] = useState([]);

    // Модальное окно размера страницы
    const [ showSizeModal, setShowSizeModal ] = useState(false);
    // Модальное окно экспорта файла
    const [ showExportModal, setShowExportModal ] = useState(false);
    // Модальное окно просмотр корзины
    const [ showCartModal, setShowCartModal ] = useState(false);
    const [ cartItems, setCartItems ] = useState([]);
    // Мобильная панель миниатюр
    const [ leftPanelOpen, setLeftPanelOpen ] = useState(false);
    // Модалка проверки книги перед оформлением
    const [ showValidationModal, setShowValidationModal ] = useState(false);

    const [showOnboarding, setShowOnboarding] = useState(() => {
        return !localStorage.getItem("first_start");
    });


    // Список ID книг из localStorage
    const [ savedBookIds, setSavedBookIds ] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("photobook_ids") || "[]");
        } catch { return []; }
    });

    // ── Загрузка корзины при старте ──
    const [cartLoaded, setCartLoaded] = useState(false);

    useEffect(() => {
        const loadCart = async () => {
            try {
                const cart = await bookApi.getCart();
                const items = (cart.items || []).map(item => ({
                    title: item.book_title || "Фотокнига",
                    pagesCount: item.book_pages_count ?? 0,
                    quantity: item.quantity ?? 1,
                    size: item.book_width_mm && item.book_height_mm
                        ? `${item.book_width_mm}×${item.book_height_mm} мм` : "—",
                    coverUrl: item.book_cover_url ?? null,
                    price: item.book_price ?? null,
                    bookId: item.book_id ?? item.book,
                    bookFormatId: item.book_format ?? null,
                    widthMm: item.book_width_mm ?? null,
                    heightMm: item.book_height_mm ?? null,
                    cartItemId: item.id,
                    bookData: null,
                }));
                setCartItems(items);
                setSelectedBookIds(items.map(i => i.bookId).filter(Boolean));
            } catch (err) {
                console.warn("Ошибка загрузки корзины:", err);
            } finally {
                setCartLoaded(true);
            }
        };
        loadCart();
    }, []);

    const reloadCart = async () => {
        try {
            const cart = await bookApi.getCart();
            const items = (cart.items || []).map(item => ({
                title: item.book_title || "Фотокнига",
                pagesCount: item.book_pages_count ?? 0,
                quantity: item.quantity ?? 1,
                size: item.book_width_mm && item.book_height_mm
                    ? `${item.book_width_mm}×${item.book_height_mm} мм` : "—",
                coverUrl: item.book_cover_url ?? null,
                price: item.book_price ?? null,
                bookId: item.book_id ?? item.book,
                bookFormatId: item.book_format ?? null,
                widthMm: item.book_width_mm ?? null,
                heightMm: item.book_height_mm ?? null,
                cartItemId: item.id,
                bookData: null,
            }));
            setCartItems(items);
            setSelectedBookIds(items.map(i => i.bookId).filter(Boolean));
        } catch (err) {
            console.warn("Ошибка загрузки корзины:", err);
        }
    };


    // Синхронизация при изменении
    useEffect(() => {
        try {
            localStorage.setItem("photobook_ids", JSON.stringify(savedBookIds));
        } catch (e) {
            console.error("Ошибка сохранения в localStorage:", e);
        }
    }, [savedBookIds]);

    // Функция добавления книги в сохранённые
    const addSavedBookId = (id) => {
        setSavedBookIds(prev => {
            if (prev.includes(id)) return prev;
            return [...prev, id];
        });
    };


    
    const values = {
        sidebarOpen, setSidebarOpen,
        bookSize, setBookSize,
        currentBook, setCurrentBook, cartLoaded,
        bookId, setBookId,
        savedBookIds, setSavedBookIds, addSavedBookId,
        showMyBooksModal, setShowMyBooksModal,

        showSizeModal, setShowSizeModal,
        showExportModal, setShowExportModal,
        showCartModal, setShowCartModal,
        cartItems, setCartItems,
        selectedBookIds, setSelectedBookIds,
        leftPanelOpen, setLeftPanelOpen,
        showValidationModal, setShowValidationModal,

        showOnboarding, setShowOnboarding,
        reloadCart,
    };
    
    return (
        <LayoutContext.Provider value={values}>
            {children}
        </LayoutContext.Provider>
    );
}